export default {"src":"/_next/static/media/info-circle.8e0aab2b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};